import { APP_ROUTES } from "../constants";

export const NewsUtil = {
  buildNewsDetailPath,
};

function buildNewsDetailPath(newsCode: string): string {
  return newsCode
    ? APP_ROUTES.PAGEMANAGEMENT.NEWS.DETAIL.replace(":newsCode", newsCode)
    : APP_ROUTES.PAGEMANAGEMENT.NEWS.BASE;
}
